export default {
  columnTitle: {
    notification: 'Notification',
    createDate: 'Create Date',
    recipients: 'Recipients',
  },
};
